import { cn } from '@/lib/ui/style-helpers'

import { UserAvatar } from '@/components/shared/user-avatar/user-avatar'

type UserScoreDisplayProps = {
  userId: string
  userName?: string
  className?: string
  avatarClassName?: string
}

export const UserScoreDisplay = ({
  userId,
  userName,
  className,
  avatarClassName,
}: UserScoreDisplayProps) => (
  <div className={cn('flex items-center gap-1', className)}>
    <UserAvatar
      userId={userId}
      className={cn('!size-4 text-xs', avatarClassName)}
      withTooltip={false}
    />
    <span className='text-main-foreground-primary text-body-small'>{userName}</span>
  </div>
)
